export default "__VITE_ASSET__DjdhocxN__"